var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef } from "react";
import styled from "styled-components";
import { RiUpload2Line, RiDeleteBin6Line, RiDeleteBinLine, } from "react-icons/ri";
import { AiOutlineFilePdf } from "react-icons/ai";
import { Spinner, Toast, Toaster, ToastTitle, useId, useToastController, } from "@fluentui/react-components";
import BrandingHeader from "../../intranet/branding/components/brandingHeader";
import uploadIcon from "/public/logoUpload.svg";
import uploadIconActive from "/public/logoUploadActive.svg";
import { AssistantService } from "./AssistantService";
const UiContainer = styled.div.withConfig({ displayName: "UiContainer", componentId: "-1nt6564" }) `
  display: flex;
  flex-direction: column;
  margin-block: auto;
  gap: 20px;
  width: 100%;

  > div {
    min-width: 305px;
  }

  h3 {
    color: #3d3a3b;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 20px;
  }
`;
const UploadContainer = styled.div.withConfig({ displayName: "UploadContainer", componentId: "-1bchmfw" }) `
  display: flex;
  margin: 10% 33%;
`;
const FileUploadContianer = styled.div.withConfig({ displayName: "FileUploadContianer", componentId: "-1i65xcu" }) `
  flex: 1 1 65%;
  justify-content: center;
`;
const Table = styled.table.withConfig({ displayName: "Table", componentId: "-1btqu35" }) `
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;

  th,
  td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }

  th {
    color: #3d3a3b;
  }

  td {
    color: #3d3a3b;
  }
`;
const FileRow = styled.tr.withConfig({ displayName: "FileRow", componentId: "-11k5846" }) `
  &:hover {
    background-color: #f9f9f9;
    cursor: pointer;
  }
`;
const UploadMessage = styled.h2.withConfig({ displayName: "UploadMessage", componentId: "-13qnmxz" }) `
  color: #3d3a3b;
  font-weight: 600;
  font-size: 18px; // Adjust the size as needed
  text-align: center;
  margin-bottom: 20px; // Space before the upload box
`;
const UploadButton = styled.button.withConfig({ displayName: "UploadButton", componentId: "-1ilu05y" }) `
  background-color: #512da8;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  margin-top: 20px;
  margin-right: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    background-color: #433d62;
  }
`;
const FileUploadIcon = styled.img.withConfig({ displayName: "FileUploadIcon", componentId: "-r8vilt" }) ``;
const FileUpload = styled.div.withConfig({ displayName: "FileUpload", componentId: "-rp1tls" }) `
  background: rgba(175, 173, 178, 0.04);
  border: 1px dashed rgba(81, 45, 168, 0.2);
  border-radius: 10px;
  padding: 20px 60px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #3d3a3b;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.2s ease-in-out;

  &:before {
    content: "Start uploading knowledge";
    position: relative;
    top: -6rem;
    display: block;
    font-size: 18px;
    color: #3d3a3b;
    font-weight: 400;
  }
  .upload-icon-active {
    display: none;
  }

  &.drag-over {
    border-color: rgba(81, 45, 168, 1);

    .upload-icon {
      display: none;
    }

    .upload-icon-active {
      display: block;
    }
  }

  input {
    display: none;
  }

  p {
    margin-block: 0 10px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;

    + p {
      font-size: 12px;
      font-weight: 400;
    }
  }

  span {
    cursor: pointer;
    color: #512da8;
  }
`;
const DeleteIcon = styled(RiDeleteBinLine).withConfig({ displayName: "DeleteIcon", componentId: "-kew8pd" }) `
  cursor: pointer;
  &:hover {
    color: #ff1744;
  }
`;
const TableHeaderCheckbox = styled.th.withConfig({ displayName: "TableHeaderCheckbox", componentId: "-pae5uz" }) `
  position: relative;
  padding: 10px;
  > div {
    position: relative;
    height: 100%;
    width: 100%;
  }
  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    top: 10px;
    left: 10px;
    text-align: left;
  }

  &:hover input[type="checkbox"] {
    opacity: 1;
  }
`;
const SpinnerContainer = styled.div.withConfig({ displayName: "SpinnerContainer", componentId: "-fx86gp" }) `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  width: 50vw;
`;
const AssistantContainer = styled.div.withConfig({ displayName: "AssistantContainer", componentId: "-1hjxchc" }) `
  position: relative;
  opacity: ${({ isDeleting }) => (isDeleting ? 0.5 : 1)};
`;
const Overlay = styled.div.withConfig({ displayName: "Overlay", componentId: "-1vin064" }) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1000;
`;
const Assistant = () => {
    const [files, setFiles] = useState([]);
    const [rawFiles, setRawFiles] = useState([]); // [1
    const [selectedFiles, setSelectedFiles] = useState(new Set());
    const [isLoading, setIsLoading] = useState(true);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isFileUploadNeeded, setFileUploadNeeded] = useState(false);
    const FileInputRef = React.useRef(null);
    const hasFetchedFiles = useRef(false);
    const toasterId = useId("toaster");
    const { dispatchToast } = useToastController(toasterId);
    const notifyWarning = (message) => dispatchToast(_jsx(Toast, { children: _jsx(ToastTitle, { children: message }) }), { intent: "warning" });
    const handleUploadFiles = () => __awaiter(void 0, void 0, void 0, function* () {
        const tenantId = JSON.parse(sessionStorage.getItem("User")).tenantId;
        const formData = new FormData();
        yield rawFiles.forEach((file, index) => {
            formData.append(`file${index}`, file, file.name);
        });
        try {
            yield AssistantService.uploadFiles(tenantId, formData);
        }
        catch (error) {
            console.error("Failed to upload files:", error);
        }
    });
    const handleDragOver = (event) => {
        event.preventDefault();
        event.currentTarget.classList.add("drag-over");
    };
    const handleDragLeave = (event) => {
        event.preventDefault();
        event.currentTarget.classList.remove("drag-over");
    };
    const handleFileSelect = (fileName) => {
        const newSelection = new Set(selectedFiles);
        if (newSelection.has(fileName)) {
            newSelection.delete(fileName);
        }
        else {
            newSelection.add(fileName);
        }
        setSelectedFiles(newSelection);
    };
    const handleDrop = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        event.currentTarget.classList.remove("drag-over");
        let droppedFiles = Array.from(event.dataTransfer.files);
        let totalSize = droppedFiles.reduce((total, file) => total + file.size, 0);
        if (totalSize > 30 * 1024 * 1024) {
            notifyWarning("Files exceeding 30MB limit are not allowed.");
            droppedFiles = [];
        }
        setRawFiles((prevRawFiles) => [...prevRawFiles, ...droppedFiles]);
        const newFiles = droppedFiles.map((file) => ({
            name: file.name,
            size: file.size,
            uploadDate: new Date(),
        }));
        setFileUploadNeeded(true);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    });
    const handleSelected = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        let selectedFiles = event.target.files
            ? Array.from(event.target.files)
            : [];
        let totalSize = selectedFiles.reduce((total, file) => total + file.size, 0);
        if (totalSize > 30 * 1024 * 1024) {
            notifyWarning("Files exceeding 30MB limit are not allowed.");
            selectedFiles = [];
        }
        setRawFiles((prevRawFiles) => [...prevRawFiles, ...selectedFiles]);
        const newFiles = selectedFiles.map((file) => ({
            name: file.name,
            size: file.size,
            uploadDate: new Date(),
        }));
        setFileUploadNeeded(true);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        event.target.value = "";
    });
    const handleDeleteSelected = () => __awaiter(void 0, void 0, void 0, function* () {
        const tenantId = JSON.parse(sessionStorage.getItem("User")).tenantId;
        for (let fileName of selectedFiles) {
            try {
                setIsDeleting(true);
                yield AssistantService.deleteFile(tenantId, fileName);
                console.log(`File deleted: ${fileName}`);
            }
            catch (error) {
                console.error(`Error deleting file: ${fileName}`, error);
            }
            finally {
                setIsDeleting(false);
            }
        }
        setFileUploadNeeded(false);
        setFiles(files.filter((file) => !selectedFiles.has(file.name)));
        setRawFiles(rawFiles.filter((rawFile) => !selectedFiles.has(rawFile.name)));
        setSelectedFiles(new Set());
    });
    const handleDeleteFile = (fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const tenantId = JSON.parse(sessionStorage.getItem("User")).tenantId;
        setIsDeleting(true);
        try {
            yield AssistantService.deleteFile(tenantId, fileName);
            setFileUploadNeeded(false);
            setFiles(files.filter((file) => file.name !== fileName));
            setRawFiles(rawFiles.filter((rawFile) => rawFile.name !== fileName));
            selectedFiles.delete(fileName);
            setSelectedFiles(new Set([...selectedFiles]));
            console.log(`File deleted: ${fileName}`);
        }
        catch (error) {
            console.error(`Error deleting file: ${fileName}`, error);
        }
        finally {
            setIsDeleting(false);
        }
    });
    const inputUpload = () => {
        FileInputRef.current.click();
    };
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            const newSelection = new Set(files.map((file) => file.name));
            setSelectedFiles(newSelection);
        }
        else {
            setSelectedFiles(new Set());
        }
    };
    const allSelected = files.length > 0 && selectedFiles.size === files.length;
    React.useEffect(() => {
        if (isFileUploadNeeded) {
            if (files.length > 0) {
                handleUploadFiles();
            }
        }
    }, [files]);
    React.useEffect(() => {
        if (hasFetchedFiles.current)
            return;
        hasFetchedFiles.current = true;
        const tenantId = JSON.parse(sessionStorage.getItem("User")).tenantId;
        const fetchFiles = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setIsLoading(true);
                const files = yield AssistantService.getFiles(tenantId);
                console.log(files);
                const newFiles = files.results.map((file) => ({
                    name: file.fileName,
                    size: file.contentLength,
                    uploadDate: new Date(file.uploadedAt),
                    fileLink: file._links[0].href.split("?")[0],
                }));
                setFiles((prevFiles) => [...prevFiles, ...newFiles]);
            }
            catch (error) {
                console.error("Error fetching files:", error);
            }
            finally {
                setIsLoading(false);
            }
        });
        fetchFiles();
    }, []);
    return (_jsxs("div", { children: [_jsx(BrandingHeader, { title: "Assistant", summary: "Expand the AI's knowledge base by uploading PDFs with valuable content.", advancedSettings: false }), isLoading ? (_jsx(SpinnerContainer, { children: _jsx(Spinner, { size: "medium", label: "Loading files...", labelPosition: "below" }) })) : (_jsxs(AssistantContainer, Object.assign({ isDeleting: isDeleting }, { children: [isDeleting && (_jsx(Overlay, { children: _jsx(Spinner, { size: "medium", label: "Deleting files...", labelPosition: "below" }) })), files.length === 0 ? (_jsx(UiContainer, { children: _jsx(UploadContainer, { children: _jsx(FileUploadContianer, { children: _jsxs(FileUpload, Object.assign({ onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop }, { children: [_jsx(FileUploadIcon, { className: "upload-icon", src: uploadIcon }), _jsx(FileUploadIcon, { className: "upload-icon-active", src: uploadIconActive }), _jsxs("p", { children: ["Drag and drop the file or", " ", _jsx("span", Object.assign({ onClick: inputUpload }, { children: "upload from desktop" })), "."] }), _jsx("p", { children: ".PDF files only" }), _jsx("input", { type: "file", ref: FileInputRef, onChange: (e) => handleSelected(e), accept: ".pdf", multiple: true })] })) }) }) })) : (_jsxs(_Fragment, { children: [_jsxs(Table, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx(TableHeaderCheckbox, { children: _jsx("input", { type: "checkbox", onChange: handleSelectAll, checked: allSelected, disabled: files.length === 0 }) }), _jsx("th", { children: "Name" }), _jsx("th", { children: "Upload Date" }), _jsx("th", { children: "Size" }), _jsx("th", {})] }) }), _jsx("tbody", { children: files.map((file) => (_jsxs(FileRow, { children: [_jsx("td", { children: _jsx("input", { type: "checkbox", checked: selectedFiles.has(file.name), onChange: () => handleFileSelect(file.name) }) }), _jsx("td", { children: _jsxs("div", Object.assign({ style: { display: "flex", alignItems: "center" } }, { children: [_jsx(AiOutlineFilePdf, { style: { marginRight: "8px" } }), file.name] })) }), _jsx("td", { children: file.uploadDate.toLocaleString() }), _jsxs("td", { children: [(file.size / 1024).toFixed(2), " KB"] }), _jsx("td", { children: _jsx(DeleteIcon, { onClick: () => handleDeleteFile(file.name) }) })] }, file.name))) })] }), _jsxs(UploadButton, Object.assign({ onClick: inputUpload }, { children: [_jsx(RiUpload2Line, {}), "Upload New File"] })), selectedFiles.size > 1 && (_jsxs(UploadButton, Object.assign({ onClick: handleDeleteSelected }, { children: [_jsx(RiDeleteBin6Line, {}), `Delete Selected (${selectedFiles.size} files)`] }))), _jsx("input", { type: "file", ref: FileInputRef, onChange: (e) => handleSelected(e), accept: ".pdf", multiple: true, style: { display: "none" } })] }))] }))), _jsx(Toaster, { toasterId: toasterId, position: "top-end" })] }));
};
export default Assistant;
